import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useGlobalContext } from './context/GlobalContext';

const HeadManager = () => {
  const { siteInfo, currentLang } = useGlobalContext();
  const [cacheBuster, setCacheBuster] = useState(Date.now());
  const [faviconError, setFaviconError] = useState(false);

  useEffect(() => {
    setCacheBuster(Date.now());
    setFaviconError(false);
  }, [siteInfo?.favicon]);

  const handleFaviconError = () => {
    setFaviconError(true);
  };

  const defaultTitle = window.location.hostname.replace(/^www\.|\.com$/g, '') || 'Selfcare';

  const defaultFavicon = `${window.location.origin}/favicon.ico`;

  const faviconUrl = siteInfo?.favicon && !faviconError
    ? `${siteInfo.favicon}?v=${cacheBuster}`
    : defaultFavicon;

  const pageTitle = siteInfo?.libelle || defaultTitle;

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <link
        rel="shortcut icon"
        href={faviconUrl}
        onError={handleFaviconError}
      />
    

      {siteInfo?.css && (
        <link
          rel="stylesheet"
          href={siteInfo.css}
          type="text/css"
        />
      )}

      {siteInfo?.user_css && (
        <link
          rel="stylesheet"
          href={siteInfo.user_css}
          type="text/css"
        />
      )}

      {siteInfo?.typo && siteInfo?.typeTypo === 1 && (
        <link
          rel="stylesheet"
          href={`/assets/css/fonts/${siteInfo.typo}/stylesheet.css`}
          type="text/css"
        />
      )}

    
    </Helmet>
  );
};

export default HeadManager;